import React,{ useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import styles from '../styles.scss';
import { history } from 'umi';
import { getLoginUser } from '@/utils/login';



export default (props) => {
  const { dir, isShow,closeCallback,confirmClick } = props;
  const user = getLoginUser();

  if (isShow) {
    return ReactDOM.createPortal (
      <div className={styles.dialogBg}>

        <div className={styles.dialogBox} onClick={()=> {}}>
          <div className={styles.dialogHeader}>
            <label className={styles.dialogTitle}>果实兑换</label>
            <img className={styles.dialogClose} src={require('@/assets/close.png')} onClick={()=> {
              closeCallback && closeCallback();
            }}/>
          </div>

          <div className={styles.dialogItem}>
            <label>课程名称：</label>
            <label style={{flex:'1'}}>{dir.directoryName + ' ' + dir.hourName}</label>
          </div>
          <div className={styles.dialogItem}>
            <label>所需果实：</label>
            <label>{dir.convertFruit}果实</label>
          </div>
          <div className={styles.dialogItem}>
            <label>当前果实：</label>
            <label>{user.fruit}果实</label>
          </div>

          <div style={{width:'100%',height:'1px',backgroundColor:'#f0f0f0',marginTop:'15px'}}/>


          <div className={styles.dialogButton} onClick={()=> {
            confirmClick && confirmClick();
          }}>确认兑换</div>

        </div>
      </div>
    ,document.body)
  } else {
    return null;
  }

}
